import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      "font-weight": ["inherit"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getIsMobile() {
  if (typeof navigator === "undefined") {
    return false;
  }
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function getIsMobileNativeApp() {
  return /Corti/i.test(navigator.userAgent);
}

export function getIsBrowserSupported() {
  if (typeof navigator === "undefined") {
    return false;
  }
  const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return !isSafari && !isFirefox;
}

// Basically a UA sniff, but it's the best way to detect if the
// browser supports getDisplayMedia or not
export function isGetDisplayMediaSupported() {
  const isMobile = getIsMobile();
  return (
    !isMobile &&
    typeof navigator !== "undefined" &&
    navigator.mediaDevices &&
    typeof navigator.mediaDevices.getDisplayMedia === "function"
  );
}
